export const ISSUES_PAGE_CONSTANTS = {
	TITLE: 'Total issues',
	DESCRIPTION: 'Every occurrence of an accessibility issue across the product is counted.',
	BACK_BUTTON_TEXT: 'Back to Dashboard'
};
